import React, { Component } from "react";
import PropTypes from "prop-types";
import { invenioConfig } from "@config";
import { Icon, List } from "semantic-ui-react";
import { DateTime } from "luxon";

export class LoanDates extends Component {
  render() {
    const { loan } = this.props;
    const isRequest = invenioConfig.CIRCULATION.loanRequestStates.includes(
      loan.metadata.state
    );

    // Custom styles for better alignment
    const listItemStyle = {
      marginBottom: "8px",
    };

    const labelContainerStyle = {
      display: "inline-block",
      width: "140px", // Fixed width for labels to ensure alignment
    };

    const valueStyle = {
      display: "inline-block",
      textAlign: "right",
      float: "right",
    };

    return isRequest ? (
      <>
        <List.Item style={listItemStyle}>
          <div style={labelContainerStyle}>
            <label>Requested on</label>
          </div>
          <div style={valueStyle}>
            {loan.metadata.request_start_date
              ? DateTime.fromISO(loan.metadata.request_start_date).toFormat(
                  "yyyy-MM-dd"
                )
              : ""}
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <div style={labelContainerStyle}>
            <label>Expected Return Date</label>
          </div>
          <div style={valueStyle}>
            {loan.metadata.request_expire_date
              ? DateTime.fromISO(loan.metadata.request_expire_date).toFormat(
                  "yyyy-MM-dd"
                )
              : ""}
          </div>
        </List.Item>
      </>
    ) : (
      <>
        <List.Item style={listItemStyle}>
          <div style={labelContainerStyle}>
            <label>Start date</label>
          </div>
          <div style={valueStyle}>
            {loan.metadata.start_date
              ? DateTime.fromISO(loan.metadata.start_date).toFormat(
                  "yyyy-MM-dd"
                )
              : ""}
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <div style={labelContainerStyle}>
            <label>End date</label>
          </div>
          <div style={valueStyle}>
            {loan.metadata.is_overdue && <Icon name="warning" />}
            {loan.metadata.end_date
              ? DateTime.fromISO(loan.metadata.end_date).toFormat("yyyy-MM-dd")
              : ""}
          </div>
        </List.Item>
      </>
    );
  }
}

LoanDates.propTypes = {
  loan: PropTypes.object.isRequired,
};

export default LoanDates;
